import React from 'react';
const TemplateSummaryConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/reports/template-summary',
			component: React.lazy(() => import('./TemplateSummaryReport'))
		}
	]
};
export default TemplateSummaryConfig;
